import { useState } from "react"
import { useHistory } from "react-router"
import { TptkmActivationResource } from "../../../../Stores/PTKMStore/ptkmStore"
import ModalWithSepLine from "components/ProjectSpecificComponents/Elements/Global/molecules/Modals/ModalWithSepLine"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import Button from "components/ProjectSpecificComponents/Elements/Global/atoms/Buttons/Button/Button"
import DatePickerInput from "components/ProjectSpecificComponents/Elements/Global/atoms/DatePickerInput"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { usePTKMStore } from "components/ProjectSpecificComponents/Contexts/PTKMStoreContext"
import AppRequests from "components/ProjectSpecificComponents/API/AppRequests/AppRequests"
import { lostOrFinishedAdminSession } from "components/ProjectSpecificComponents/API/Functions/lostOrFinishedAdminSession"
import { useTranslation } from "react-i18next"
import React from "react"
import MediumButton from "components/ProjectSpecificComponents/Elements/Global/atoms/Buttons/MediumButton"
import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
import FormField from "../FormField"
import Checkbox from "components/ProjectSpecificComponents/Elements/Global/atoms/Checkbox"
import { observer } from "mobx-react-lite"
import { entries, forEach } from "lodash"

interface Props {}

export const PTKM_REQ_CLASSNAME = "ptkm-req-input-field"

const ActivatePTKMForm = observer(({}: Props) => {
	const store = useStore()
	const history = useHistory()
	const ptkmStore = usePTKMStore()

	const [dateModalOpen, setDateModalOpen] = useState<boolean>(false)
	const [date, setDate] = useState<string>()

	const { deadlines } = ptkmStore.ptkmConfig

	const activateConfig = async (activate: boolean) => {
		// Finds all visible req. classname and checks if input has value
		let foundMissingField: boolean = false
		document.querySelectorAll(`.${PTKM_REQ_CLASSNAME}`).forEach((e: any) => {
			switch (e.nodeName) {
				case "DIV":
					if (!e?.textContent) foundMissingField = true
					return e.classList.toggle("req-input", !e?.textContent)
				case "INPUT":
					if (!e?.value) foundMissingField = true
					return e.classList.toggle("req-input", !e?.value)
			}
		})

		if (foundMissingField) {
			store.setInfoModalConfig({
				type: "fail",
				titleKey: "rawText.all-fields-not-completed",
			})
			return
		}

		if (!!activate && !date) return

		// restart modal
		setDateModalOpen(false)
		setDate(undefined)

		// Saves PTKM config and activate or deactivate
		store.setLoaderOverlayOpen(true)
		//Have to clean state to uptade table
		const { ok, data, statusCode } = await AppRequests("PTKM").put<TptkmActivationResource>(
			"activatePTKMConfig",
			activate
				? {
						calculateFrom: date,
						config: { ...ptkmStore.ptkmConfig, isActive: true },
				  }
				: { config: { ...ptkmStore.ptkmConfig, isActive: false } },
			{
				formsConfigId: ptkmStore.ptkmConfig.id,
			}
		)

		if (ok) {
			history.push(ROUTES.PTKM)
			store.setInfoModalConfig({
				type: "info",
				titleKey: activate ? "ptkm.activated" : "ptkm.deactivated",
				showDuration: 1000,
			})
		} else if (statusCode == 401) {
			lostOrFinishedAdminSession(history, store)
		} else {
			store.setInfoModalConfig({
				type: "fail",
				titleKey: typeof data === "string" ? data : "error.action-failed",
			})
		}
		store.setLoaderOverlayOpen(false)
	}

	const { t } = useTranslation()

	return (
		<>
			{dateModalOpen && (
				<ModalWithSepLine onClose={() => setDateModalOpen(false)}>
					<p>{t("ptkm.calc-deadline-from-date")}</p>

					<br />
					<div className="flex flex-row w-full justify-between">
						<DatePickerInput value={date} onChangeDate={setDate} />
						<Whitespace x=".5" h />
						<Button disabled={!date} onClick={() => activateConfig(true)}>
							{t("button.continue")}
						</Button>
					</div>
				</ModalWithSepLine>
			)}
			{!!ptkmStore?.ptkmConfig?.isActive ? (
				<MediumButton onClick={() => activateConfig(false)}>
					{t("ptkm.deactivate-ptkm")}
				</MediumButton>
			) : (
				<MediumButton onClick={() => setDateModalOpen(true)}>
					{t("button.activate-ptkm")}
				</MediumButton>
			)}
		</>
	)
})

export default ActivatePTKMForm
